import { render, staticRenderFns } from "./CaseCategorization.vue?vue&type=template&id=efbf314c&"
import script from "./CaseCategorization.vue?vue&type=script&lang=js&"
export * from "./CaseCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports